require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/values.js
// module id = cb8ff069bcc1c283f49f
// module chunks = 5